import { jsx as t, jsxs as r } from "react/jsx-runtime";
import * as B from "react";
import "react/compiler-runtime";
import "@mui/material";
import { Button as D } from "../../atoms/Button/Button.js";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "@mui/icons-material";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "react-dom/server";
import "@mui/icons-material/Warning";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
import '../../../assets/map.css';import '../../../assets/FilterWrapper.css';/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Close";
import "@mui/icons-material/Search";
import "../../atoms/Box/Box.js";
import "../../atoms/Grid/Grid.js";
import { Typography as T } from "../../atoms/Typography/Typography.js";
import "@mui/material/styles";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Dialog";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "@mui/icons-material/Menu";
import "../../organisms/SunburstGraph/SunburstGraph.js";
import "../../organisms/RadarGraph/RadarGraph.js";
import "../../organisms/ScoreGauge/ScoreGauge.js";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../../organisms/DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../../organisms/Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "@mui/icons-material/ArrowForward";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "../../organisms/ReactMap/index.js";
import "@mui/material/Button";
import "../../organisms/ReactMap/GMapStatic.js";
import "../../../chunks/index.esm.js";
import "@mui/icons-material/Clear";
import "../../atoms/FormControl/FormControl.js";
import "../../atoms/FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
/* empty css                   */
import "../../atoms/Paper/Paper.js";
import "../../atoms/Radio/Radio.js";
import "../../atoms/RadioGroup/RadioGroup.js";
import "../../atoms/Menu/Menu.js";
import "../../atoms/MenuItem/MenuItem.js";
import "../../atoms/Table/Table.js";
import "../../atoms/TableBody/TableBody.js";
import "../../atoms/TableHead/TableHead.js";
import "../../atoms/TableRow/TableRow.js";
import "../../atoms/TableCell/TableCell.js";
import "../../atoms/ToggleButton/ToggleButton.js";
import "../../atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import "@mui/icons-material/ExpandMore";
import "../../atoms/Stepper/Stepper.js";
import "../../atoms/Step/Step.js";
import "../../atoms/StepLabel/StepLabel.js";
import "../../atoms/Link/Link.js";
import { LoadingButton as v } from "../../atoms/LoadingButton/LoadingButton.js";
import "../../atoms/LinearProgress/LinearProgress.js";
import "../../atoms/Stack/Stack.js";
import "../../atoms/Card/Card.js";
import "../../atoms/CardActions/CardActions.js";
import "../../atoms/FormHelperText/FormHelperText.js";
import "../../atoms/AccordionDetails/AccordionDetails.js";
import "../../atoms/TableContainer/TableContainer.js";
import { DialogBox as A, DialogTitle as j, DialogContent as k, DialogActions as w } from "../../atoms/Dialog/Dialog.js";
function fr(a) {
  const {
    open: l,
    setOpen: n,
    title: c,
    message: d,
    onCancel: i,
    onConfirm: m,
    confirmText: s = "OK",
    cancelText: f = "Cancel",
    cancelButton: g = !0,
    confirmButton: u = !0,
    confirmColor: h = "primary",
    children: y,
    disable: b = !1,
    errors: C
  } = a, [x, p] = B.useState(!1), e = () => {
    n(!1);
  };
  return /* @__PURE__ */ t("div", { children: /* @__PURE__ */ r(A, { "data-testid": "alert-dialog-container", open: l, onClose: e, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [
    /* @__PURE__ */ t(j, { id: "alert-dialog-title", children: c }),
    /* @__PURE__ */ r(k, { children: [
      /* @__PURE__ */ t(T, { variant: "body1", children: d }),
      y
    ] }),
    /* @__PURE__ */ r(w, { children: [
      g && /* @__PURE__ */ t(D, { "data-testid": "alert-dialog-cancel-btn", onClick: () => {
        try {
          i && i(), e();
        } catch (o) {
          throw console.log(o), o;
        }
      }, sx: {
        textTransform: "uppercase"
      }, children: f }),
      u && /* @__PURE__ */ t(v, { "data-testid": "alert-dialog-confirm-btn", variant: "contained", color: h, disabled: C?.length ? !0 : b, loading: x, onClick: async () => {
        try {
          p(!0), m && await m();
        } catch (o) {
          console.log("Alert : ", o);
        } finally {
          p(!1);
        }
      }, autoFocus: !0, children: s })
    ] })
  ] }) });
}
export {
  fr as AlertDialog,
  fr as default
};
